var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "135.2,188.6 135.2,0 11.3,0 11.3,500 135.2,500 135.2,311.3 364.8,311.3 427,250.3 364.8,188.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00D2B7",
    points: "364.8,500 488.7,500 488.7,311.3 427,250.3 364.8,311.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00D2B7",
    points: "488.7,0 364.8,0 364.8,188.6 427,250.3 488.7,188.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkLogo);
export default __webpack_public_path__ + "static/media/HK-logo.77e6757c8d4062d1f0c17cf50c7bb13c.svg";
export { ForwardRef as ReactComponent };